<alert [nom]="NOM_ALERTE_ERREUR_GENERALE" class="alerte" nomBouton="GLOBAL.OUI"></alert>

<div class="accueil">
	<div class="accueil-header">
		<div class="switch-masquer-reservations" [hidden]="true">
			<label for="switchMasquerReservations">{{ 'ACCUEIL.SWITCH_MASQUER_RESERVATION' | translate }}</label>
			<p-inputSwitch id="switchMasquerReservations" [(ngModel)]="masquerReservations" (onChange)="onChangeMasquerReservations($event)"/>
		</div>
	</div>
	<div class="accueil-container">
		<div class="calendar-container">
			<app-calendrier [masquerReservations]="masquerReservations()" [afficherWeekend]="afficherWeekend()" (plagesSelectionneesChange)="this.plagesSelectionnees.set($event)"></app-calendrier>
		</div>
		<div class="right-side">
			<app-declarer-evenement [plagesSelectionnees]="plagesSelectionnees()" (notifierCreationEvenement)="onCreationEvenements()"></app-declarer-evenement>
		</div>
	</div>
</div>
